<template>
    <v-card-title>
        <v-container class="pa-12">
            <v-card class="pl-16 pr-16 pt-8 pb-16">
                <v-card-title>
                    <v-row>
                        <v-col cols="6" md="6" justify="center">
                            <h3>Edit Document</h3>
                        </v-col>
                    </v-row>
                </v-card-title>

                <v-row class="row1 mt-3  pt-3 ">
                    <v-col cols="12" md="7">
                        <v-text-field v-model="doctype" outlined dense label="Document Type" background-color="#F5F5F5"
                            disabled></v-text-field>
                    </v-col>
                </v-row>

                <br />

                <template>
                    <template>
                        <v-data-table :headers="headers" :items="desserts" sort-by="calories" class="elevation-1 ">
                            <template v-slot:item.title="{ item }">
                                <v-text-field v-model="item.title" dense class="mt-6" outlined
                                    @blur="editItemTitle(item)"></v-text-field>
                            </template>
                            <template v-slot:item.type="{ item }">
                                <div v-if="item.type == 'Dropdown'">
                                    <v-expansion-panels v-model="item.ShowDrop" accordion class="mb-2 mt-2">
                                        <v-expansion-panel>
                                            <v-expansion-panel-header>{{ item.type }}</v-expansion-panel-header>
                                            <v-expansion-panel-content class="mt-3">
                                                <v-row class="ml-2" v-if="item.datadropdown.length > 0"
                                                    v-for="(data, index) in item.datadropdown" :key="index">
                                                    <v-row>
                                                        <v-col cols="12" sm="9">
                                                            <v-text-field v-model="item.datadropdown[index].text" dense
                                                                outlined label="Drowdown item"
                                                                @blur="updateDocdrop(data)"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" sm="2">
                                                            <v-btn @click="deleteDocdrop(data)" :style="{
                                                                backgroundColor: '#9E3B1B',
                                                                color: 'white',
                                                            }" :disabled="disabledDelete">
                                                                <v-icon small>
                                                                    mdi-delete
                                                                </v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-row>
                                                <v-row class="ml-2">
                                                    <v-row>
                                                        <v-col cols="12" sm="9">
                                                            <v-text-field v-model="item.textdrop" dense outlined
                                                                label="Drowdown item"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" sm="2">
                                                            <v-btn @click="saveDocdrop(item)" :style="{
                                                                backgroundColor: '#254E58',
                                                                color: 'white',
                                                            }">
                                                                <v-icon small>
                                                                    save
                                                                </v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-row>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </div>
                                <div v-else="">
                                    <v-row class="mt-2 mb-2 ml-3">
                                        <v-col cols="12" sm="12">
                                            {{ item.type }}
                                        </v-col>
                                    </v-row>

                                </div>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn @click="openItemTable(item.id)" :style="{
                                    backgroundColor: '#9E3B1B',
                                    color: 'white',
                                }" :disabled="disabledDelete">
                                    <v-icon small>
                                        mdi-delete
                                    </v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </template>

                    <div class="pl-2 pr-2 pt-6 pb-1 elevation-1">
                        <template>
                            <v-row>
                                <v-col cols="12" md="3" class="ml-1">
                                    <v-text-field v-model="doc_title" ref="myDocTitle" dense outlined
                                        label="Title"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-autocomplete :items="type_list" ref="myType" label="Type" dense outlined
                                        @change="showTypeDropdown()" v-model="documnet_type"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="1">
                                    <v-btn class="ml-2" :style="{
                                        backgroundColor: '#254E58',
                                        color: 'white',
                                    }" @click="saveItemAdd()"> <span>Save</span>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row v-if="showdropdown" class="ml-1" v-for="(item, index) in dropdownlist" :key="index">
                                <v-row>
                                    <v-col cols="12" md="5" offset="3">
                                        <v-text-field v-model="dropdownlist[index].text" dense outlined
                                            label="Drowdown item"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="1">
                                        <v-btn v-if="index == 0" :style="{
                                            backgroundColor: '#a7c4ae',
                                            color: 'green',
                                        }" icon>
                                            <v-icon @click="inputapprover">mdi-plus</v-icon>
                                        </v-btn>
                                        <v-btn v-else="" :style="{
                                            backgroundColor: '#FFEBEE',
                                            color: '#F44336',
                                        }" icon @click="deletedropdown(index)">
                                            <v-icon>mdi-minus</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>

                            </v-row>
                        </template>
                    </div>
                </template>
                <br />
                <div>
                    <v-row class="mt-2">
                        <v-col cols="12" md="12">
                            <v-span>
                                <h5>Setup Department Authorization</h5>
                            </v-span>
                        </v-col>
                    </v-row>
                    <v-row class="mt-0">
                        <v-col cols="12" md="10">
                            <v-select v-model="authori_depart" outlined dense ref="myDep" :items="depart_list"
                                item-text="department_name" item-value="id" multiple></v-select>
                        </v-col>
                    </v-row>
                </div>
                <br />
                <br />
                <div>
                    <v-row>
                        <v-col align="center" cols="12" md="12">
                            <v-btn depressed width="100" class="mr-5" :style="{
                                backgroundColor: '#254E58',
                                color: 'white',
                            }" @click="saveDepartAu()">
                                Save
                            </v-btn>
                            <v-btn depressed width="100" class="mr-5 buttonred" :disabled="disabledDelete"
                                @click="openDeleteAll()">
                                Delete
                            </v-btn>
                            <v-btn depressed outlined width="100" to="/document-setup">
                                Cance
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
            <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="text-h5">
                        Are you sure you want to delete this item?
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete">
                            Cancel
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemTable">
                            OK
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDeleteAll" max-width="500px">
                <v-card>
                    <v-card-title class="text-h5">
                        Are you sure you want to delete this item?
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDeleteAll">
                            Cancel
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemTableAll">
                            OK
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

            <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message"
                :link="link" />
        </v-container>
    </v-card-title>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import {
    tolocalestringnumber,
    stringcommatonumber,
} from "./computing/tolocalestringnumber";

export default {
    name: "NewAdvance",
    data() {
        return {
            doc_title: "",
            doctype: "",
            type_list: ["Dropdown", "Text", "Date", "Number"],
            dialogAdd: false,
            text_color: "text-h5 green--text text-center",
            title: "green",
            message: "green",
            link: "",
            documnet_type: "",
            doctemplate_id_delete: 0,
            dialogDelete: false,
            dialogDeleteAll: false,
            disabledDelete: false,
            showdropdown: false,
            desserts: [],
            authori_depart: [],
            depart_list: [],
            dropdownlist: [
                {
                    text: ""
                }
            ],
            dropdownlistTable: [
                {
                    text: ""
                }
            ],
            headers: [
                {
                    text: "Title",
                    value: "title",
                    class: "bg-colorth",
                    align: "start",
                    divider: true,
                    sortable: false,
                    width: "25%",
                },
                {
                    text: "Type",
                    align: "start",
                    value: "type",
                    class: "bg-colorth",
                    align: "start",
                    divider: true,
                    sortable: false,
                    width: "50%",
                },
                {
                    value: "actions",
                    align: "center",
                    class: "bg-colorth texttablehcenter",
                    width: "25%",
                    divider: true,
                    sortable: false,
                },
            ]
        };
    },
    components: {
        SuccessDialog,
        SuccessDialogPush,
    },
    computed: {
    },
    watch: {
    },
    async mounted() {
        const userId = localStorage.getItem(server.USER_ID);
        if (userId && api.isLoggedIn()) {
            // this.$router.push("/");
        } else {
            this.$store.state.isLogged = false;
            this.$router.push("/login");
        }
        await this.loadDepartment();
        await this.loadDoctrans();
        await this.loadDoctype();
        await this.loadDoctypeTemplate();
        this.$hideLoader();
    },
    methods: {
        async loadDepartment() {
            const res_depart = await api.getNewAllDepartment_By_CompanyID(localStorage.getItem(server.COMPANYID));
            console.log(res_depart.data)
            this.depart_list = res_depart.data;
        },
        async loadDoctrans() {
            const res_doctrans = await api.getDocTransByDoctye(this.$route.params.doctype_id)
            if (res_doctrans.data.length > 0) {
                this.disabledDelete = true;
            }
        },
        async loadDoctype() {
            const res_doctype = await api.getDoctypeByID(this.$route.params.doctype_id)
            this.doctype = res_doctype.data[0].doctype;
            if (res_doctype.data[0].department_authorization != "") {
                const dep_au = res_doctype.data[0].department_authorization
                const temp_dep = dep_au.split(',');
                for (let i = 0; i < temp_dep.length; i++) {
                    temp_dep[i] = Number(temp_dep[i])
                }
                // console.log(temp_dep)
                this.authori_depart = temp_dep;

            }

        },
        async loadDoctypeTemplate() {
            const res_doctypetemplate = await api.getDoctypeTemplateByID(this.$route.params.doctype_id)
            this.desserts = res_doctypetemplate.data;
            this.desserts.forEach(async (item) => {
                if (item.type == "Dropdown") {
                    const res_docdrop = await api.getDocDropByDoctempID(item.id)
                    item.datadropdown = res_docdrop.data;
                } else {
                    item.datadropdown = [];
                }
                item.textdrop = "";
            })
            console.log(this.desserts)

        },
        async saveItemAdd() {
            // console.log(this.doc_title)
            // console.log(this.documnet_type)
            if (this.doc_title == "") {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Check information",
                    "Please Enter Document Type Data",
                    "text-h5 red--text text-center"
                );
                this.$refs["myDocTitle"].focus();
                return;
            }
            if (this.documnet_type == "") {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Check information",
                    "Please Enter Document Type Data",
                    "text-h5 red--text text-center"
                );
                this.$refs["myType"].focus();
                return;
            }

            const additem = {
                doctype_id: this.$route.params.doctype_id,
                title: this.doc_title,
                type: this.documnet_type
            }
            if (this.showdropdown) {
                // console.log(this.dropdownlist)
                for (let i = 0; i < this.dropdownlist.length; i++) {
                    if (this.dropdownlist[i].text == "") {
                        this.$store.state.global_dialog = true;
                        this.setupAlertDialog(
                            true,
                            "Check information",
                            "Please Enter Dropdown Item Data",
                            "text-h5 red--text text-center"
                        );
                        return;
                    }
                }
                const res_additem = await api.CreateDoctypeTemplate(additem);
                if (res_additem.status == 200) {
                    this.$showLoader();
                    for (let i = 0; i < this.dropdownlist.length; i++) {
                        const addDocDropItem = {
                            doctemplate_id: res_additem.data.id,
                            text: this.dropdownlist[i].text,
                        }
                        const add_drop = await api.CreateDocDropDown(addDocDropItem)
                        if (add_drop.status != 200) {
                            this.doc_title = "";
                            this.documnet_type = "";
                            this.showdropdown = false;
                            this.dropdownlist = [{
                                text: ""
                            }]
                            await api.DeleteDocDropDown(add_drop.data.id)
                            this.$hideLoader();
                            this.$store.state.global_dialog = true;
                            this.setupAlertDialog(
                                true,
                                "Check information",
                                "Add Data fail",
                                "text-h5 red--text text-center"
                            );
                            return;
                        }
                    }
                    this.doc_title = "";
                    this.documnet_type = "";
                    this.showdropdown = false;
                    this.dropdownlist = [{
                        text: ""
                    }]
                    await this.loadDoctypeTemplate();
                    this.$hideLoader();

                } else {
                    this.doc_title = "";
                    this.documnet_type = "";
                    this.$hideLoader();
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                        true,
                        "Check information",
                        "Please Enter Document Type Data",
                        "text-h5 red--text text-center"
                    );
                    return;
                }
            } else {
                this.$showLoader();
                const res_additem = await api.CreateDoctypeTemplate(additem);
                if (res_additem.status == 200) {
                    await this.loadDoctypeTemplate();
                    this.doc_title = "";
                    this.documnet_type = "";
                    this.$hideLoader();
                } else {

                    this.doc_title = "";
                    this.documnet_type = "";
                    this.$hideLoader();
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                        true,
                        "Check information",
                        "Please Enter Document Type Data",
                        "text-h5 red--text text-center"
                    );
                    return;
                }

            }
        },
        async editItemTitle(data) {
            if (data.title == "") {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Check information",
                    "Please Enter Title Data",
                    "text-h5 red--text text-center"
                );
                await this.loadDoctypeTemplate()
                return;
            }
            this.$showLoader();
            const res_update = await api.UpdateDoctypeTemplate(data.id, { title: data.title })
            if (res_update.status != 200) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Check information",
                    "Add Data fail",
                    "text-h5 red--text text-center"
                );
                this.$hideLoader();
                return;
            }
            await this.loadDoctypeTemplate()
            this.$hideLoader();
        },
        async saveDocdrop(data) {
            if (data.textdrop == "") {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Check information",
                    "Please Dropdown Item Data",
                    "text-h5 red--text text-center"
                );
                await this.loadDoctypeTemplate()
                return;
            }
            const adddocdrop = {
                doctemplate_id: data.id,
                text: data.textdrop,
            }
            this.$showLoader();
            const res_addDropdoc = await api.CreateDocDropDown(adddocdrop)
            if (res_addDropdoc.status != 200) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Check information",
                    "Add Data fail",
                    "text-h5 red--text text-center"
                );
                this.$hideLoader();
                return;

            }
            await this.loadDoctypeTemplate()
            this.$hideLoader();
        },
        async updateDocdrop(data) {
            if (data.text == "") {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Check information",
                    "Please Dropdown Item Data",
                    "text-h5 red--text text-center"
                );
                await this.loadDoctypeTemplate()
                return;
            }
            this.$showLoader();
            const res_updateDocdrop = await api.updateDocDropDown(data.id, { text: data.text })
            if (res_updateDocdrop.status != 200) {
                this.$hideLoader();
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Check information",
                    "Update Data fail",
                    "text-h5 red--text text-center"
                );
                return;
            }
            await this.loadDoctypeTemplate()
            this.$hideLoader();
        },
        async saveDepartAu() {
            // if (this.authori_depart.length == 0) {
            //     this.$store.state.global_dialog = true;
            //     this.setupAlertDialog(
            //         true,
            //         "Check information",
            //         "Please Enter Department Authorization  Data",
            //         "text-h5 red--text text-center"
            //     );
            //     this.$refs["myDep"].focus();
            //     return;
            // }
            this.$showLoader();
            let dep_authri_id = "";
            this.authori_depart.forEach((item, index) => {
                if (index == (this.authori_depart.length - 1)) {
                    dep_authri_id = dep_authri_id + item;
                } else {
                    dep_authri_id = dep_authri_id + item + ",";
                }


            })
            const res_update_dep = await api.UpdateDoctype(
                this.$route.params.doctype_id,
                {
                    department_authorization: dep_authri_id
                }
            )
            if (res_update_dep.status != 200) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Check information",
                    "Add Data fail",
                    "text-h5 red--text text-center"
                );
                this.$hideLoader();
                return;

            }
            this.authori_depart = [];
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
                true,
                "Information Saved",
                "Information successfully saved",
                "text-h5 green--text text-center",
                `/document-setup`
            );
            this.$hideLoader();
        },
        async deleteDocdrop(data) {
            this.$showLoader();
            const res_deletedrop = await api.DeleteDocDropDownByID(data.id)
            if (res_deletedrop.status != 200) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Check information",
                    "Add Data fail",
                    "text-h5 red--text text-center"
                );
                this.$hideLoader();
                return;

            }
            await this.loadDoctypeTemplate()
            this.$hideLoader();
        },
        async openDeleteAll() {
            this.dialogDeleteAll = true;
        },
        closeDeleteAll() {
            this.dialogDeleteAll = false;
        },
        async deleteItemTableAll() {
            this.$showLoader();
            this.desserts.forEach(async (item) => {
                await api.DeleteDocDropDown(item.id);
                await api.DeleteDoctypeTemplate(item.id);
            })
            await api.DeleteDoctype(this.$route.params.doctype_id);
            this.dialogDeleteAll = false;
            this.$hideLoader();
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
                true,
                "Information Saved",
                "Information successfully saved",
                "text-h5 green--text text-center",
                `/document-setup`
            );

        },
        async openItemTable(doctemplate_id) {
            this.dialogDelete = true;
            this.doctemplate_id_delete = doctemplate_id;
        },
        closeDelete() {
            this.dialogDelete = false;
            this.doctemplate_id_delete = 0;
        },
        async deleteItemTable() {
            this.$showLoader();
            await api.DeleteDocDropDown(this.doctemplate_id_delete)
            await api.DeleteDoctypeTemplate(this.doctemplate_id_delete)
            this.dialogDelete = false;
            await this.loadDoctypeTemplate();
            this.$hideLoader();
        },
        showTypeDropdown() {
            // alert(this.documnet_type)
            if (this.documnet_type == "Dropdown") {
                this.showdropdown = true;
            } else {
                this.showdropdown = false;
                this.dropdownlist = [{
                    text: ""
                }]
            }
        },
        async inputapprover() {
            this.dropdownlist.push({
                text: ""
            });
        },
        async deletedropdown(index) {
            this.dropdownlist.splice(index, 1);
        },
        async inputapproverTable() {
            this.dropdownlistTable.push({
                text: ""
            });

        },
        async deletedropdownTable(index) {
            this.dropdownlistTable.splice(index, 1);
        },
        setupAlertDialog(status, title, message, text_color) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
        },
        setupAlertDialogPush(status, title, message, text_color, link) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
            this.link = link;
        },
    },
    async beforeCreate() {
        console.log("beforeCreate");
        this.$store.state.navMenu = true;
    },
};
</script>
<style scoped>
.v-btn:not(.v-btn--round).v-size--default.buttonred {
    background-color: #9e3b1b;
    color: white;
}

.test_show {
    font-size: 17px;
}
</style>